import React from 'react';
import { observer } from 'mobx-react';
import { MdFilterList } from 'react-icons/md';
import { pick } from 'lodash';
import ConversationSearch from '../ConversationSearch';
import DepartmentsFilter from '../DepartmentsFilter';
import ChannelSelect from './ChannelSelect';
import AgentsFilter from '../AgentsFilter';
import LabelsFilter from '../LabelsFilter';
import { SEARCH_MIN_QUERY } from '../../../constants';
import { dropdownMenu } from './DropdownMenu';
import { createExtraActionsMenu } from './DropdownMenu';
import { useStore } from '../../../store/rootStore';
import { getDirection } from '../../../helpers';
import useCheckIfMobile from '../../../helpers/hooks/useCheckIfMobile';
import s from './ChatsList.module.scss';
const Filters = ({ resolve, onSearch, loading, agentsVisible, departmentsVisible, labelsVisible, totalCount }) => {
    const { channels, chatsStore } = useStore();
    const filtersApplied = Object.values(pick(chatsStore.searchFilter, ['agent', 'department', 'labels'])).filter(Boolean).length;
    const isMobile = useCheckIfMobile();
    const { menu: extraActionsMenu, MenuComponent: ExtraActionsMenuComponent } = createExtraActionsMenu({ resolve, totalCount });
    return (React.createElement("div", { className: s.filtersContainer },
        React.createElement(ConversationSearch, { minQuery: SEARCH_MIN_QUERY, onSearch: onSearch, dropdownIcon: MdFilterList, channelSelect: React.createElement(ChannelSelect, { accounts: channels.accounts, activeChannel: chatsStore.channel, onChannelClick: chatsStore.setChannel, className: s.channelSelectMobile, size: "large", dropdownStyle: !isMobile ? { width: 360, minWidth: 360 } : { width: 'calc(100vw - 16px)', minWidth: 'calc(100vw - 16px)' }, placement: getDirection() === 'rtl' ? 'bottomRight' : 'bottomLeft' }), dropdownMenu: isMobile ? (dropdownMenu({
                resolve,
                filtersApplied,
                agents: agentsVisible ? React.createElement(AgentsFilter, { fullwidth: true }) : null,
                departments: departmentsVisible ? React.createElement(DepartmentsFilter, { fullWidth: true }) : null,
                labels: labelsVisible ? React.createElement(LabelsFilter, { fullwidth: true }) : null,
                resetFilters: chatsStore.resetFilters,
            })) : null, extraActionsMenu: resolve ? extraActionsMenu : undefined, loading: loading, filtersApplied: filtersApplied }),
        !isMobile && (React.createElement(React.Fragment, null, (agentsVisible || departmentsVisible || labelsVisible) && (React.createElement("div", { className: s.filtersBlock },
            departmentsVisible && React.createElement(DepartmentsFilter, { fullWidth: !agentsVisible }),
            agentsVisible && React.createElement(AgentsFilter, { fullwidth: !departmentsVisible }),
            labelsVisible && React.createElement(LabelsFilter, { fullwidth: true }))))),
        resolve && React.createElement(ExtraActionsMenuComponent, null)));
};
export default observer(Filters);
